import { array, object, number, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { emailRegex } from 'common/utils/helpers';

export default () => {
    const { EMAIL_VALIDATION_TEXT, NUMBER_TYPE_TEXT, REQUIRED_TEXT } =
        getValidationTexts();

    let validation = {
        emails: array().of(
            object({
                email: string()
                    .matches(emailRegex, EMAIL_VALIDATION_TEXT)
                    .nullable(),
                email_type: string().nullable(),
            }),
        ),
        name: string().required(REQUIRED_TEXT).nullable(),
        telephones: array().of(
            object({
                phone_type: string().nullable(),
                telephone: number().typeError(NUMBER_TYPE_TEXT).nullable(),
            }),
        ),
    };

    return object().shape(validation);
};
